import { render, staticRenderFns } from "./guide-list-card.vue?vue&type=template&id=06d8c4a3&scoped=true&"
import script from "./guide-list-card.vue?vue&type=script&lang=js&"
export * from "./guide-list-card.vue?vue&type=script&lang=js&"
import style0 from "./guide-list-card.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./guide-list-card.vue?vue&type=style&index=1&id=06d8c4a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d8c4a3",
  null
  
)

export default component.exports
import {QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QIcon})
